import { render } from "./employee_general_tab.vue?vue&type=template&id=3446ef70"
import script from "./employee_general_tab.vue?vue&type=script&lang=js"
export * from "./employee_general_tab.vue?vue&type=script&lang=js"

import "./employee_general_tab.vue?vue&type=style&index=0&id=3446ef70&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__